import {useDispatch, useSelector} from "react-redux";
import {Button} from "@material-ui/core";
import {LocalizerHelper} from "../../helpers/localizerHelper";
import RestaurantHeader from "../restaurant/RestaurantHeader";
import Screen from '../screen';
import './index.scss';
import { RootState } from "../../store";
import { useParams } from "react-router";
import { auth } from "../../firebase";

const obfuscateMail = (mail:string | null) => {

    if(mail == null || mail.trim() == '') return '';

    mail = mail.trim();
    let splitted, part1,part2, firtChar, endChar;
    splitted = mail.split("@");
    part1 = splitted[0];
    firtChar = part1.substring(0, 1);
    endChar = part1.substring(part1.length - 1);
    part1 = part1.substring(1, (part1.length - 2));
    part1 = part1.replace(/./g,'*');
    part2 = splitted[1];
    return `${firtChar}${part1}${endChar}@${part2}`;
}

const ThanksPage = () => {  
    const dispatch = useDispatch();  
    const { 
        link_alias: link_alias, 
    } = useParams<{ link_alias: string }>();

    const lastLinkAlias = (window.localStorage) ? (window.localStorage.getItem('chuzeat_last_alias_link') ?? '' ) : '';

    const session = useSelector((state: RootState) => state.session.session);

    const newOrder = () => {
        const alias = link_alias ?? lastLinkAlias;
        const url = `/menu/${alias}`
        window.location.href = url
    }

    return (
        <Screen className="screen thanks_screen">
            <RestaurantHeader className={'block'} showBack={false} showCart={false}/>
            <div className="container content_container content_container_thanks_order">
                <div className="container_code_order">
                    <div className="title">{LocalizerHelper.localized('thanks_header')}</div>
                    <div className="subtitle">{LocalizerHelper.localized('thanks_label_order_delivery_takeaway')}</div>
                    <div className="code">{session?.code}</div>
                </div>

                <div className="row container_description_order">
                    <div className="col-md-12 text-left label_text">
                        <p>{LocalizerHelper.localized('thanks_page_success_payment_message')}</p>
                    </div>
                </div>
                <div className="row container_mail_order">
                    <div className="col-md-12 text-left label_text">
                        <p className="email-address-label">{obfuscateMail(auth.currentUser?.email ?? "")}</p>
                    </div>
                </div>
                <div className="row container-buttons-action">
                    <div className="col-md-12">
                        <Button className='accent-button full-width button button' onClick={() => newOrder()}>
                            {LocalizerHelper.localized('new_order')}
                        </Button>
                    </div>
                </div>

            </div>
            

        </Screen>);
};

export default ThanksPage;
